
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class CelestialBodyEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const drawBody = (x: number, y: number, r: number) => {
             ctx.save();
             ctx.translate(x, y);
             
             // Planet silhouette
             ctx.beginPath();
             ctx.arc(0, 0, r, 0, Math.PI * 2);
             ctx.stroke();
             
             // Atmosphere glow
             ctx.save();
             ctx.globalAlpha *= 0.2;
             const grad = ctx.createRadialGradient(0, 0, r, 0, 0, r * 1.5);
             grad.addColorStop(0, pc.color);
             grad.addColorStop(1, 'transparent');
             ctx.fillStyle = grad;
             ctx.beginPath();
             ctx.arc(0, 0, r * 1.5, 0, Math.PI * 2);
             ctx.fill();
             ctx.restore();

             // Rings if any
             if (this.pseudoRandom(x) > 0.5) {
                 ctx.save();
                 ctx.rotate(Math.PI / 6);
                 ctx.globalAlpha *= 0.3;
                 ctx.beginPath();
                 ctx.ellipse(0, 0, r * 2.5, r * 0.4, 0, 0, Math.PI * 2);
                 ctx.stroke();
                 ctx.restore();
             }
             ctx.restore();
        };

        const draw = () => {
             const bx = (this.pseudoRandom(layerIndex) - 0.5) * width;
             const by = (this.pseudoRandom(layerIndex + 10) - 0.5) * height;
             drawBody(bx, by, 150 * scale / (layerIndex + 1));
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
